import Lord from '../pages/lord/pages/home/reducers'

export default {
  Lord,
}
